import React from 'react';
import { AlertTriangleIcon, CheckIcon, StarIcon } from 'lucide-react';
import { purchaseUrls } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const baseFeatures = ['6 Tomos PDF completos (Semanas 1 a 52)', 'Evaluación inicial completa con 8 tests validados', '156 clases completamente desarrolladas', '6 Bonos estratégicos gratis', 'Acceso inmediato', 'Garantía de 7 días'];
const premiumFeatures = ['TODO el Combo Completo Entrenamiento para Adultos Mayores', 'Adaptaciones completas para 12 condiciones de salud: Parkinson, ACV, osteoporosis, artrosis, hipertensión, diabetes, prótesis y más', 'Guía maestra de progresiones para adaptar cualquier ejercicio en segundos', '8 herramientas de registro imprimibles: evaluación, seguimiento, fuerza, equilibrio, asistencia y objetivos', 'Módulo de organización profesional: grupos heterogéneos, circuitos, reincorporaciones', 'Recursos exclusivos: estimulación cognitiva, desafíos grupales y estrategias de motivación anual'];
function PlanCard({
  premium = false
}: {
  premium?: boolean;
}) {
  const features = premium ? premiumFeatures : baseFeatures;
  const title = premium ? 'Combo Completo + Mega Kit Adultos Mayores' : 'Combo Completo Entrenamiento para Adultos Mayores';
  const subtitle = premium ? '6 Tomos + 6 Bonos + Upsell Premium' : '6 Tomos + 6 Bonos';
  const price = premium ? '$27.990' : '$19.990';
  const before = premium ? '$90.000' : '$76.000';
  const savings = premium ? '$63.000' : '$56.000';
  return <article className={`relative flex flex-col rounded-3xl p-6 md:p-8 ${premium ? 'border-4 border-gold bg-primary text-white shadow-[0_25px_60px_rgba(234,88,12,.35)] ring-4 ring-gold/30 md:scale-[1.025]' : 'border border-orange-100 bg-white shadow-sm'}`} data-id="element-271" data-mp="2tlj47z9ps7x0">
      {premium && <div className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full border-2 border-amber-200 bg-gold px-4 py-1.5 text-xs font-extrabold text-white shadow-lg" data-id="element-272" data-mp="3ced9u2lg6nok">
          <StarIcon className="h-4 w-4 fill-current" data-id="element-273" data-mp="2eyqrgg1m6fjh" /> MÁS ELEGIDO
        </div>}
      <div className={premium ? 'mt-2' : ''} data-id="element-274" data-mp="2j0lnb50s00pv">
        <div className="flex items-start gap-2" data-id="element-275" data-mp="2izu30qcmppew">
          <span className="text-3xl" data-id="element-276" data-mp="2nsdixtysgwmv">{premium ? '💎' : '📚'}</span>
          <h3 className={`text-xl font-extrabold leading-tight ${premium ? 'text-white' : 'text-slate-900'}`} data-id="element-277" data-mp="2ntoljqghzyce">
            {title}
          </h3>
        </div>
        <p className={`mt-2 text-sm font-medium ${premium ? 'text-orange-100' : 'text-slate-500'}`} data-id="element-278" data-mp="2xo6sd4h7oa0f">
          {subtitle}
        </p>
      </div>

      <p className={`my-6 rounded-xl border p-4 text-sm leading-relaxed ${premium ? 'border-white/20 bg-white/10 text-orange-50' : 'border-orange-100 bg-orange-50/70 text-slate-600'}`} data-id="element-279" data-mp="36r7xp2y95x31">
        <b className={premium ? 'text-white' : 'text-slate-900'} data-id="element-280" data-mp="1cd6vq97eotyq">Ideal para:</b>{' '}
        {premium ? 'Profesionales que quieren el sistema completo MÁS la guía maestra de adaptaciones para patologías, herramientas de gestión profesional y todos los recursos exclusivos para llevar su práctica al siguiente nivel.' : 'Profesores de educación física, entrenadores personales, kinesiólogos y centros de jubilados que quieren un sistema completo, progresivo y listo para aplicar durante todo el año.'}
      </p>

      <ul className="mb-6 flex-1 space-y-2" data-id="element-281" data-mp="1isxehxlmfsal">
        {features.map(feature => <li key={feature} className={`flex items-start gap-2 text-sm font-medium ${premium ? 'text-white' : 'text-slate-700'}`} data-id="element-282" data-mp="1iquc0e3a86oz">
            <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${premium ? 'text-amber-300' : 'text-accent'}`} data-id="element-283" data-mp="19rh3poqw9o5u" />
            {feature}
          </li>)}
      </ul>

      <div className="mb-6" data-id="element-284" data-mp="3uhgavw047t7e">
        <span className={`mb-3 inline-block rounded-full px-3 py-1 text-xs font-extrabold ${premium ? 'bg-gold text-white' : 'bg-orange-100 text-primary'}`} data-id="element-285" data-mp="3uh6iy2vifbz2">
          AHORRÁS {savings}
        </span>
        <p className={`mt-2 text-sm font-bold line-through ${premium ? 'text-orange-200' : 'text-slate-400'}`} data-id="element-286" data-mp="1d93gka6q5saw">
          Antes: {before}
        </p>
        <p className={`mt-1 text-xs font-bold uppercase ${premium ? 'text-orange-100' : 'text-slate-500'}`} data-id="element-287" data-mp="1haygba90bxmk">
          Hoy
        </p>
        <p className={`text-4xl font-extrabold ${premium ? 'text-white md:text-5xl' : 'text-slate-900'}`} data-id="element-288" data-mp="29zvwn7tnrkco">
          {price}
        </p>
      </div>

      <Button href={premium ? purchaseUrls.premium : purchaseUrls.base} fullWidth className={premium ? 'border-2 border-amber-100 bg-gold text-xs shadow-[0_0_0_5px_rgba(245,158,11,.28)] hover:bg-amber-600' : 'text-xs'} data-id="element-289" data-mp="1w1xk87ywdxzt">
        {premium ? 'QUIERO COMBO COMPLETO + MEGA KIT ADULTOS MAYORES' : 'QUIERO EL SISTEMA COMBO COMPLETO ADULTOS MAYORES'}
      </Button>
    </article>;
}
export function Pricing({
  id = 'pricing'
}: {
  id?: string;
}) {
  return <section id={id} className="mx-auto max-w-6xl scroll-mt-16 px-4 py-16 md:py-24" data-id="element-290" data-mp="qzmwwoid7gw8">
      <div className="text-center" data-id="element-291" data-mp="m1bo8h3t3cfl">
        <p className="text-[11px] font-bold uppercase tracking-[.16em] text-accent md:text-sm" data-id="element-292" data-mp="m24pj2jzx9qc">
          ⏰ Precio de lanzamiento activo hoy
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl text-2xl font-extrabold leading-tight text-slate-900 md:text-4xl" data-id="element-293" data-mp="3pituik3xkbdw">
          Asegurá el precio promocional <span className="text-accent" data-id="element-294" data-mp="83eo5aq58nw6">antes de que suba.</span>
        </h2>
        <div className="mt-6" data-id="element-295" data-mp="3a2cs2ah6dld">
          <Countdown data-id="element-296" data-mp="39sja4q81oax" />
        </div>
        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-297" data-mp="3bqnh35s5wii5">
          {['Después sube $9.000 ARS', 'Esta promo no vuelve', '68% de los cupos ya tomados'].map(item => <span key={item} className="inline-flex items-center gap-1 rounded-full border border-red-200 bg-red-50 px-3 py-1.5 text-[11px] font-bold text-red-600" data-id="element-298" data-mp="1aoxn3k2bv6gi">
                <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-299" data-mp="1kdz4neoitvwl" />
                {item}
              </span>)}
        </div>
      </div>

      <h2 className="mt-14 text-center text-3xl font-extrabold text-slate-900 md:text-5xl" data-id="element-300" data-mp="1oi6szar2h9ua">
        Elegí tu <span className="text-accent" data-id="element-301" data-mp="rrwi3z8rx6ck">opción</span>
      </h2>
      <div className="mx-auto mt-10 grid max-w-5xl gap-8 md:grid-cols-2" data-id="element-302" data-mp="wpxy2bawkpjt">
        <PlanCard data-id="element-303" data-mp="10q038ufuk13u" />
        <PlanCard premium data-id="element-304" data-mp="10pgiz72q50mn" />
      </div>
      <p className="mt-9 text-center text-xs font-medium text-slate-500" data-id="element-305" data-mp="10sm8uoj6g6jf">
        Pago 100% seguro · Acceso en 5 minutos · Mercado Pago hasta 12 cuotas
      </p>
    </section>;
}